"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mastercard = void 0;
var React = __importStar(require("react"));
var Mastercard = function () {
    return (React.createElement("svg", { width: 36, height: 27, viewBox: "0 0 36 27", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("g", { filter: "url(#filter0_d_277_4923)" },
            React.createElement("g", { filter: "url(#filter1_d_277_4923)" },
                React.createElement("rect", { x: 1.5, y: 1.5, width: 33, height: 23, rx: 3.5, fill: "#F7F7F8", stroke: "#D8D8DA" })),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.179 17.83a6.802 6.802 0 01-4.398 1.6c-3.745 0-6.781-3-6.781-6.7s3.036-6.7 6.78-6.7c1.679 0 3.215.602 4.399 1.6a6.802 6.802 0 014.398-1.6c3.745 0 6.781 3 6.781 6.7s-3.036 6.7-6.78 6.7a6.802 6.802 0 01-4.399-1.6z", fill: "#ED0006" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.18 17.83a6.653 6.653 0 002.382-5.1c0-2.042-.925-3.87-2.383-5.1a6.802 6.802 0 014.399-1.6c3.744 0 6.78 3 6.78 6.7s-3.036 6.7-6.78 6.7a6.802 6.802 0 01-4.399-1.6z", fill: "#F9A000" }),
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.179 17.83a6.653 6.653 0 002.382-5.1c0-2.042-.924-3.87-2.382-5.1a6.653 6.653 0 00-2.383 5.1c0 2.042.925 3.87 2.383 5.1z", fill: "#FF5E00" })),
        React.createElement("defs", null,
            React.createElement("filter", { id: "filter0_d_277_4923", x: 0, y: 0.5, width: 36, height: 26, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_277_4923" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_277_4923", result: "shape" })),
            React.createElement("filter", { id: "filter1_d_277_4923", x: 0, y: 0.5, width: 36, height: 26, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                React.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                React.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
                React.createElement("feOffset", { dy: 0.5 }),
                React.createElement("feGaussianBlur", { stdDeviation: 0.5 }),
                React.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" }),
                React.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_277_4923" }),
                React.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_277_4923", result: "shape" })))));
};
exports.Mastercard = Mastercard;
